import { useAtom } from 'jotai';
import { v4 as uuid } from 'uuid';
import { ActionHistory, futureAtom, pastAtom } from './historyAtoms';
import { useUpdateCJSeance } from './useUpdateCJSeance';
import { useDeleteCJSeances } from './useDeleteCJSeances';
import { useCreateCJSeances } from './useCreateCJSeances';
import { CJEvent } from 'types/event';
import { logNetworkError } from 'utils/errors';
import { useSetCJSeanceStatus } from './useSetCJSeanceStatus';

export function useRedoCJ() {
  const [past, setPast] = useAtom(pastAtom);
  const [future, setFuture] = useAtom(futureAtom);
  const setCJSeancesStatus = useSetCJSeanceStatus(true);
  const updateEvent = useUpdateCJSeance(true);
  const removeEvents = useDeleteCJSeances(true);
  const createEvents = useCreateCJSeances(true);

  return () => {
    const [firstItem, ...restFuture] = future;
    setFuture(restFuture);
    switch (firstItem.action) {
      case 'CREATE':
        setPast([
          ...past,
          {
            action: 'DELETE',
            payload: firstItem.payload as CJEvent[],
          },
        ]);
        return removeEvents(firstItem.payload as CJEvent[]);
      case 'RESTORE':
        setPast([
          ...past,
          {
            action: 'DELETE',
            payload: firstItem.payload as CJEvent[],
          },
        ]);
        return removeEvents(firstItem.payload as CJEvent[]);
      case 'DELETE': {
        const items = (firstItem.payload as CJEvent[]).map(evt => ({
          ...evt,
          id: uuid(),
        }));
        setPast([
          ...past,
          {
            action: 'CREATE',
            payload: items,
          },
        ]);
        return createEvents({ cjEvents: items }).catch(err => {
          logNetworkError(err, "Couldn't create cj event when redo");
        });
      }
      case 'UPDATE': {
        const [oldEvent, newEvent] = firstItem.payload as CJEvent[];
        setPast([
          ...past,
          {
            action: 'UPDATE',
            payload: [newEvent, oldEvent] as CJEvent[],
          },
        ]);
        return updateEvent({
          event: oldEvent,
          previousDay: newEvent.start,
        });
      }
      case 'UPDATE_STATUS': {
        const { status, date } = firstItem.payload;
        setPast([
          ...past,
          {
            action: 'UPDATE_STATUS',
            payload: {
              date,
              status: status === 'done' ? 'open' : 'done',
            },
          },
        ]);
        return setCJSeancesStatus({
          date,
          status,
        });
      }

      default:
        throw new Error(
          `history action not recognized : ${
            (firstItem as ActionHistory).action
          }`,
        );
    }
  };
}
